import { t } from "@redotech/redo-i18n";
import {
  Condition,
  Condition as ModelCondition,
} from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import * as React from "react";
import {
  ConditionType,
  ConditionTypeDetailsProps,
} from "../../return-flow/condition";

export type SentFromEmailState = Omit<Condition.SentFromEmail, "type">;

export const SENT_FROM_EMAIL = (
  Details: React.ComponentType<ConditionTypeDetailsProps<SentFromEmailState>>,
): ConditionType<SentFromEmailState, Condition.SentFromEmail> => ({
  name: CONDITION_NAMES[Condition.SENT_FROM_EMAIL],
  description() {
    return t("The email address of the sender of the email");
  },
  Details(props: ConditionTypeDetailsProps<SentFromEmailState>) {
    return React.createElement(Details, props);
  },
  empty: { emails: [], matchMode: "INCLUDES" },
  fromModel(model) {
    return { emails: model.emails, matchMode: model.matchMode };
  },
  toModel(state) {
    return {
      type: ModelCondition.SENT_FROM_EMAIL,
      emails: state.emails,
      matchMode: state.matchMode,
    };
  },
  valid(state) {
    return !!state.emails.length;
  },
});
